import { cn } from '../../lib/cn';

type Props = { className?: string; lines?: number };

export function Skeleton({ className, lines = 1 }: Props) {
  if (lines <= 1) {
    return <div className={cn('animate-pulse rounded-md bg-slate-200 dark:bg-slate-700', className ?? 'h-4 w-full')} aria-hidden="true" />;
  }
  return (
    <div className="space-y-2" aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <div key={i} className={cn('animate-pulse rounded-md bg-slate-200 dark:bg-slate-700 h-4', i === lines - 1 ? 'w-2/3' : 'w-full')} />
      ))}
    </div>
  );
}

export function KpiSkeleton() {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-700 dark:bg-slate-900">
      <Skeleton className="h-3 w-24" />
      <Skeleton className="mt-2 h-8 w-32" />
    </div>
  );
}
